export default __webpack_public_path__ + "static/media/special-instruction.4a612d14.png";